import Box from '@mui/material/Box';

export default function BannerImage({ banner }) {
    return (
        <>
            {banner?.image && (
                <Box
                    className={'banner-img'}
                    sx={{
                        maxWidth: '100%',
                        width: '100%',
                        height: { md: '336px', xs: 'auto' },
                        minHeight: { md: 'auto', xs: '100px', sm: '200px' },
                        margin: '0 auto',
                        marginBottom: { xs: '-15%', sm: 0 },
                        overflow: 'hidden',
                        backgroundColor: banner.background,
                        textAlign: banner.alignment || 'center',
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        position: 'relative',
                        placeContent:
                            banner.alignment === 'left' ? 'start' : banner.alignment === 'right' ? 'end' : 'center',
                        zIndex: -1,
                    }}
                >
                    <img
                        alt={'banner'}
                        src={banner.image}
                        className={'banner-img'}
                        style={{
                            maxWidth: '1440px',
                            height: 'auto',
                            width: banner.cover === 'fill' ? '100%' : 'auto',
                            backgroundSize: banner.cover === 'fill' ? 'cover' : 'contain',
                            WebkitBackgroundSize: banner.cover === 'fill' ? 'cover' : 'contain',
                            backgroundRepeat: 'no-repeat',
                            objectFit: banner.cover === 'fill' ? 'cover' : 'contain',
                            backgroundPosition: 'center top',
                        }}
                    />
                </Box>
            )}
        </>
    );
}
